import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, TextField, Grid, Button, Box } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Autocomplete } from "formik-mui";
import { TextField as TextF } from "formik-material-ui";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import styles from "./overlay.module.css";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import ConfirmDeleteDialog from "./confirm-delete";

const CustomColorCheckbox = withStyles({
  root: {
    color: "#23AFC4",
    "&$checked": {
      color: "#23AFC4",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function JournalAddNote({
  getJournalData,
  selectedDate,
  noteDetails,
  readJournal,
  setReadJournal,
  setOpen,
  open,
}) {
  const axiosInstance = useAxiosPrivate();
  const [groups, setGroups] = useState([]);
  const [players, setPlayers] = useState([]);
  const [checked, setChecked] = React.useState(false);
  const [userNameClicked, setUserNameClicked] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
  const handleClickOpen = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  // handle delete
  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`/journal/${noteDetails.id}`);
      getJournalData();

      setOpenDelete(false);
      handleClose();

      // setAlert({
      //     showAlert: true,
      //     severity: 'success',
      //     message: 'Note deleted successfully!',
      // });
    } catch {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Note deletion failed!",
      });
    }
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const handleClose = () => {
    setReadJournal(false);
    setOpen(false);
    setChecked(false);
    setIsSubmitting(false);
    setAlert({
      showAlert: false,
      severity: "success",
      message: "",
    });
  };

  const [initialValues, setInitialValues] = useState({
    group_id: "",
    player_id: "",
    reading_time: "",
    title: "",
    note: "",
    is_group_note: false,
    visibility: "private",
    display_date: "",
  });

  let JournalValidationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Title is required.")
      .max(60, "Maximum length for the title is 60."),
    note: Yup.string()
      .required("Note is required.")
      .max(255, "Maximum length for the note is 255."),
  });

  const loadData = async () => {
    try {
      console.log('from add journal note : /user/profile and /team/players ');
      const [profile, players] = await Promise.all([
        axiosInstance.get("/user/profile"),
        axiosInstance.get("/team/players"),
      ]);

      const mappedPlayersData = players.data.data.map((item) => {
        item.name = `${item.first_name} ${
          item.last_name ? item.last_name : ""
        }`;
        return item;
      });

      setGroups(profile.data.data.groups);
      setPlayers(mappedPlayersData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (open) {
      // Reset alert state when opening dialog
      setAlert({
        showAlert: false,
        severity: "success",
        message: "",
      });
      loadData();
      const d = new Date();
      const readDate =
        d.toDateString().split(" ").join(", ") + " " + d.toLocaleTimeString();
      const reading_time =
        d.toISOString().split("T")[0] + " " + d.toISOString().split("T")[1];
      if (readJournal) {
        const userName = players.filter(
          (item) => item?.user_id === noteDetails?.player_id
        )[0]?.first_name;
        setUserNameClicked(userName);
        setInitialValues((prev) => ({
          group_id: noteDetails?.group_id,
          player_id: noteDetails?.player_id,
          reading_time: reading_time,
          title: noteDetails?.title,
          note: noteDetails?.note,
          is_group_note: noteDetails?.is_group_note,
          visibility: noteDetails?.visibility,
          display_date: readDate,
          id: noteDetails?.id,
        }));
        if (noteDetails?.visibility === "group") {
          setChecked(true);
        }
      } else {
        setInitialValues({
          group_id: "",
          player_id: "",
          title: "",
          note: "",
          is_group_note: false,
          visibility: "private",
          display_date: readDate,
          reading_time: reading_time,
        });
      }
    }
    // eslint-disable-next-line
  }, [open, readJournal]);

  const submit = async (payload) => {
    // Prevent duplicate submissions
    if (isSubmitting) return;
    
    try {
      setIsSubmitting(true);
      setLoading(true);
      const { note, title } = payload;

      const data = {
        reading_time: moment(selectedDate).format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss"),
        title,
        note,
        is_group_note: false,
        visibility: !checked ? "private" : "group",
      };
      if (payload.group_id) {
        data.group_id = payload.group_id.id;
        data.is_group_note = true;
        data.player_id = payload.player_id.user_id;
      } else {
        data.group_id = payload.player_id.team_id;
        data.player_id = payload.player_id.user_id;
      }

      if (data.group_id) {
        try {
          await axiosInstance.post("/journal/add", data);
          // Batch state updates to prevent multiple re-renders
          setLoading(false);
          setAlert({
            showAlert: true,
            severity: "Success",
            message: "Note saved successfully!",
          });

          getJournalData();
          handleClose();
          setIsSubmitting(false);
          
        } catch {
          setIsSubmitting(false);
          setLoading(false);
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Note sending failed!",
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: "error",
              message: "Note sending failed!",
            });
          }, 5000);
        }
      }
    } catch (error) {
      setIsSubmitting(false);
      setLoading(false);
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Note sending failed!",
      });
      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "error",
          message: "Note sending failed!",
        });
      }, 5000);
    }
  };

  return (
    <div>
      <div>
        <Dialog
          maxWidth="md"
          fullWidth
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              paddingRight: "2rem",
              paddingTop: "2rem",
            }}
          >
            <ModalCloseButton onClick={handleClose} style={{ position: "static" }} />
          </Box>

          <Formik
            initialValues={initialValues}
            onSubmit={submit}
            validationSchema={JournalValidationSchema}
            enableReinitialize
          >
            {({ dirty, isValid, touched, errors, values }) => (
              <Form style={{ padding: "0 2.5rem 2.5rem 2.5rem" }} readOnly>
                <DialogContent>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Grid item md={3}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {readJournal ? (
                          <p className={styles.makePublic} style={{ fontWeight: 500, fontSize: "1rem", margin: 0 }}>
                            Public: {noteDetails?.visibility === "group" ? "Yes" : "No"}
                          </p>
                        ) : (
                          <>
                            <CustomColorCheckbox
                              style={{
                                transform: "scale(0.7)",
                                padding: 0,
                              }}
                              checked={checked}
                              onChange={handleChange}
                              disabled={readJournal}
                            />
                            <p className={styles.makePublic}>
                              {!readJournal ? "Make this public" : "Public"}
                            </p>
                          </>
                        )}
                      </div>
                    </Grid>
                    <Grid item md={4} style={{ paddingLeft: "2rem" }}>
                      {!readJournal ? (
                        <Field
                          name="group_id"
                          component={Autocomplete}
                          disabled={readJournal}
                          options={groups}
                          getOptionLabel={(option) => option.name || ""}
                          getOptionSelected={(option, value) =>
                            option.name === value.name
                          }
                          // style={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              // We have to manually set the corresponding fields on the input component
                              name="group_id"
                              error={
                                touched["group_id"] && !!errors["group_id"]
                              }
                              helperText={errors["group_id"]}
                              label={
                                <span className={styles.autoSelect}>
                                  Pick Team
                                </span>
                              }
                              // InputProps={{ style: { padding: '10px' } }}
                              variant="outlined"
                            />
                          )}
                        />
                      ) : null}
                    </Grid>
                    <Grid item md="auto">
                      {!readJournal ? (
                        <p className={styles.autoSelect}>Or</p>
                      ) : null}
                    </Grid>
                    <Grid item md={4} style={{ paddingRight: "2rem" }}>
                      {userNameClicked || !readJournal ? (
                        <Field
                          name="player_id"
                          component={Autocomplete}
                          options={players}
                          disabled={readJournal}
                          getOptionLabel={(option) => option.name || ""}
                          getOptionSelected={(option, value) =>
                            option.name === value.name
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              // We have to manually set the corresponding fields on the input component
                              name="player_id"
                              error={
                                touched["player_id"] && !!errors["player_id"]
                              }
                              helperText={errors["player_id"]}
                              label={
                                <span className={styles.autoSelect}>
                                  {!readJournal
                                    ? "Pick Patient"
                                    : userNameClicked}
                                </span>
                              }
                              variant="outlined"
                            />
                          )}
                        />
                      ) : null}
                    </Grid>
                    <Grid md={12}>
                      <Field
                        disabled={readJournal}
                        name="title"
                        component={TextF}
                        label={!readJournal ? "Add Title" : "Title"}
                        fullWidth
                        className={styles.addTitleLabel}
                      />
                    </Grid>
                    <Grid md={12}>
                      <p className={styles.dateText}>
                        {moment(selectedDate)
                          .format("dddd, MMMM DD, YYYY")
                          .toUpperCase()}
                        <span style={{ marginLeft: "2rem" }}>
                          {readJournal && noteDetails?.reading_time
                            ? moment(noteDetails.reading_time).format("h:mm:ss A")
                            : moment().format("h:mm:ss A")}
                        </span>
                      </p>
                    </Grid>
                    <Grid md={12}>
                      <Field
                        disabled={readJournal}
                        name="note"
                        component={TextF}
                        label={!readJournal ? "Take a note..." : "Note"}
                        fullWidth
                        multiline
                        rows={10}
                        className={styles.labelText}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  {!readJournal ? (
                    <Button
                      variant="contained"
                      // eslint-disable-next-line
                      disabled={
                        !isValid ||
                        (values.group_id === "" && values.player_id === "") ||
                        loading ||
                        isSubmitting
                      }
                      type="submit"
                      // eslint-disable-next-line
                      style={
                        !isValid ||
                        (values.group_id === "" && values.player_id === "") ||
                        loading
                          ? {
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontStyle: "normal",
                              width: "136px",
                              height: "35px",
                              background: "#0F9BB0",
                              opacity: 0.5,
                              borderRadius: "4px",
                              padding: "10px 20px",
                              gap: "10px",
                              color: "#ffffff",
                              textTransform: "capitalize",
                            }
                          : alert.showAlert
                          ? {
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontStyle: "normal",
                              width: "136px",
                              height: "35px",
                              borderRadius: "4px",
                              padding: "10px 20px",
                              gap: "10px",
                              backgroundColor: "white",
                              color: "#0F9BB0",
                              textTransform: "capitalize",
                              border: "2px solid",
                              borderColor: "#0F9BB0",
                            }
                          : {
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontStyle: "normal",
                              width: "136px",
                              height: "35px",
                              background: "#23AFC4",
                              borderRadius: "4px",
                              padding: "10px 20px",
                              gap: "10px",
                              color: "#ffffff",
                              textTransform: "capitalize",
                            }
                      }
                    >
                      {alert.showAlert
                        ? "Saved"
                        : loading
                        ? "Saving..."
                        : "Save"}
                    </Button>
                  ) : null}
                  {/* delete journal notes */}

                  {readJournal ? (
                    <Box style={{ textAlign: "center", width: "100%" }}>
                      <Button
                        variant="outlined"
                        style={{
                          textTransform: "none",
                          color: "#23afc4",
                          // backgroundColor:"#23afc4",
                          fontFamily: "Poppins",
                          // fontWeight: 500,
                          fontStyle: "medium",
                          fontSize: "14px",
                          borderColor: "#23afc4",
                        }}
                        onClick={handleClickOpen}
                      >
                        Delete
                      </Button>
                    </Box>
                  ) : null}
                </DialogActions>
                {alert.showAlert ? (
                  <div style={{ padding: "0.5rem 2rem" }}>
                    <Alert
                      severity={alert.severity}
                      onClose={() =>
                        setAlert({
                          ...alert,
                          showAlert: false,
                        })
                      }
                    >
                      {alert.message}
                    </Alert>
                  </div>
                ) : (
                  <p style={{ height: "1.3rem" }}></p>
                )}
              </Form>
            )}
          </Formik>
        </Dialog>
      </div>
      <ConfirmDeleteDialog
        open={openDelete}
        onClose={handleCloseDelete}
        handleDelete={handleDelete}
      />
    </div>
  );
}
